export const TRACKING_KEY = "lead_attribution";

export const captureTrackingData = () => {
  try {
    const existing = localStorage.getItem(TRACKING_KEY);

    // Preserve first-touch attribution
    if (existing) return;

    const params = new URLSearchParams(window.location.search);

    const trackingData = {
      visitor_id: crypto.randomUUID(),

      utm_source: params.get("utm_source"),
      utm_medium: params.get("utm_medium"),
      utm_campaign: params.get("utm_campaign"),
      utm_term: params.get("utm_term"),
      utm_content: params.get("utm_content"),

      gclid: params.get("gclid"),
      fbclid: params.get("fbclid"),

      landing_page: window.location.href,
      referrer: document.referrer,

      created_at: new Date().toISOString(),
    };

    // Store only if some attribution exists
    const hasAttribution =
      trackingData.utm_source ||
      trackingData.gclid ||
      trackingData.fbclid;

    if (!hasAttribution) return;

    localStorage.setItem(
      TRACKING_KEY,
      JSON.stringify(trackingData)
    );

    console.log("Tracking data stored");
  } catch (err) {
    console.error("Tracking capture failed", err);
  }
};

export const getTrackingData = () => {
  try {
    return JSON.parse(
      localStorage.getItem(TRACKING_KEY)
    );
  } catch {
    return null;
  }
};
